import { API } from 'aws-amplify';

export async function getPlans() {
  return API.get('mdp', '/plan/types', {});
}
